function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLink = function SvgLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.377 14.819c3.652 0 10.953 1.84 10.953 5.584v2.826H12.425v-2.826c0-3.745 7.302-5.584 10.953-5.584zM11.08 9.169h4.099v2.826h-4.1v4.204H8.326v-4.204h-4.1V9.169h4.1V4.965h2.755zm12.297 2.825c-3.01 0-5.445-2.497-5.445-5.585s2.434-5.65 5.445-5.65 5.445 2.563 5.445 5.65-2.434 5.585-5.445 5.585z",
    style: {
      strokeWidth: 1.03787
    }
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontSize: "9.33333px",
      lineHeight: 1.25,
      fontFamily: "sans-serif"
    },
    x: 5.19,
    y: 39.336
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 5.19,
    y: 39.336,
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: "9.33333px",
      fontFamily: "sans-serif",
      InkscapeFontSpecification: "'sans-serif Bold'"
    }
  }, "INVITE")));
};
export default SvgLink;